/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_BulkUpdateTariffRatesRequest } from '../models/billing_BulkUpdateTariffRatesRequest';
import type { billing_CreateTariffVersionRequest } from '../models/billing_CreateTariffVersionRequest';
import type { billing_TariffListResponse } from '../models/billing_TariffListResponse';
import type { billing_TariffRateRequest } from '../models/billing_TariffRateRequest';
import type { billing_TariffRateResponse } from '../models/billing_TariffRateResponse';
import type { billing_TariffVersionResponse } from '../models/billing_TariffVersionResponse';
import type { billing_UpdateTariffVersionRequest } from '../models/billing_UpdateTariffVersionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TariffsService {
    /**
     * List tariff versions
     * List all tariff versions with optional filters, search, and sorting
     * @param groupType Filter by group type
     * @param status Filter by status - comma-separated values (DRAFT, ACTIVE, EXPIRED, ARCHIVED - case insensitive)
     * @param isDefault Filter by default status
     * @param includeRates Include full rate details
     * @param search Search term to filter by name or description
     * @param sortBy Column to sort by (name, description, group_type, status, created_at)
     * @param sortOrder Sort direction (asc, desc)
     * @param limit Pagination limit (max 100)
     * @param offset Pagination offset
     * @returns billing_TariffListResponse OK
     * @throws ApiError
     */
    public static getApiV1TariffVersions(
        groupType?: string,
        status?: string,
        isDefault?: boolean,
        includeRates?: boolean,
        search?: string,
        sortBy: string = 'created_at',
        sortOrder: string = 'desc',
        limit?: number,
        offset?: number,
    ): CancelablePromise<billing_TariffListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tariff-versions',
            query: {
                'group_type': groupType,
                'status': status,
                'is_default': isDefault,
                'include_rates': includeRates,
                'search': search,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid query parameters`,
                500: `Failed to list tariff versions`,
            },
        });
    }
    /**
     * Create a new tariff version
     * Create a new tariff version with rates
     * @param request Tariff version details
     * @returns billing_TariffVersionResponse Created
     * @throws ApiError
     */
    public static postApiV1TariffVersions(
        request: billing_CreateTariffVersionRequest,
    ): CancelablePromise<billing_TariffVersionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tariff-versions',
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Failed to create tariff version`,
            },
        });
    }
    /**
     * Update a tariff version
     * Update an existing tariff version
     * @param id Tariff version ID
     * @param request Updated tariff version details
     * @returns billing_TariffVersionResponse OK
     * @throws ApiError
     */
    public static putApiV1TariffVersions(
        id: string,
        request: billing_UpdateTariffVersionRequest,
    ): CancelablePromise<billing_TariffVersionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tariff-versions/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Tariff version not found`,
                500: `Failed to update tariff version`,
            },
        });
    }
    /**
     * Set a tariff version as default
     * Set a tariff version as the default for its group type
     * @param id Tariff version ID
     * @returns billing_TariffVersionResponse OK
     * @throws ApiError
     */
    public static putApiV1TariffVersionsSetDefault(
        id: string,
    ): CancelablePromise<billing_TariffVersionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tariff-versions/{id}/set-default',
            path: {
                'id': id,
            },
            errors: {
                404: `Tariff version not found`,
                500: `Failed to set default version`,
            },
        });
    }
    /**
     * Get tariffs for a specific version
     * Get all tariff rates for a specific tariff version
     * @param id Tariff version ID
     * @returns billing_TariffRateResponse OK
     * @throws ApiError
     */
    public static getApiV1TariffVersionsTariffs(
        id: string,
    ): CancelablePromise<Array<billing_TariffRateResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tariff-versions/{id}/tariffs',
            path: {
                'id': id,
            },
            errors: {
                404: `Tariff version not found`,
                500: `Failed to get tariffs`,
            },
        });
    }
    /**
     * Create or update a tariff rate
     * Create a new tariff rate or update if it already exists
     * @param id Tariff version ID
     * @param request Tariff rate details
     * @returns billing_TariffRateResponse OK
     * @throws ApiError
     */
    public static postApiV1TariffVersionsTariffs(
        id: string,
        request: billing_TariffRateRequest,
    ): CancelablePromise<billing_TariffRateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tariff-versions/{id}/tariffs',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Failed to create/update tariff`,
            },
        });
    }
    /**
     * Batch update tariff rates
     * Update multiple tariff rates at once for a specific version
     * @param id Tariff version ID
     * @param request Bulk update request
     * @returns any Update summary
     * @throws ApiError
     */
    public static putApiV1TariffVersionsTariffs(
        id: string,
        request: billing_BulkUpdateTariffRatesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tariff-versions/{id}/tariffs',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Failed to update tariffs`,
            },
        });
    }
}
